import { useMsal } from '@azure/msal-react'
import { Box, Flex, HStack, Image, Spacer, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import moment from 'moment'
import React, { useState } from 'react'
import { AiFillPrinter } from 'react-icons/ai'
import TableRow from './TableRow'

export default function PrintSra({ SingleData, onClick }) {

    console.log("single data", SingleData)

    const { instance } = useMsal();
    const currentAccount = instance.getActiveAccount();
    console.log("currentAcc", currentAccount);


    const [Hide, setHide] = useState(false);

    const printNow = () => {
        setHide(true)

        setTimeout(() => {
            window.print()

        }, 1000);
        setTimeout(() => {
            setHide(false)


        }, 2000);
    }
    return (
        <Box mx={"6%"} py="32px">

            <HStack>
                <Image src='/logo.jpg' width={"10%"} />
                <Spacer />
                {
                    !Hide && (

                        <Text cursor={"pointer"} fontSize={"20px"} fontWeight="500" onClick={onClick}>{"<"} Back </Text>
                    )
                }
            </HStack>
            <Text mt="10px" fontSize={"20px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Eko eletricity distribution company</Text>

            <HStack>
                <HStack spacing={"30px"} mt="5px" >

                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600"> Date: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{moment(Date.now()).format("DD/MM/YYYY")} </Text>
                    </HStack>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Cost Center:  </Text>
                        <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.costcenter} </Text>
                    </HStack>
                   

                </HStack>
                <Spacer />
                {
                    !Hide && (

                        <HStack fontSize={"20px"} cursor="pointer" onClick={printNow}>
                            <Box><AiFillPrinter /></Box>
                            <Text color="#fff" bgColor="navy" fontSize={"14"} px="8px" py="3px" rounded="8px">Print</Text>
                        </HStack>
                    )
                }
            </HStack>
            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>SRA Details</Text>

            <Stack spacing={"10px"} borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <HStack spacing={"25%"} borderBottomColor={"grey"} borderWidth="1px" pb="5px">
                    <Stack spacing={"10px"}>
                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">SRA no: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.sranumber} </Text>
                        </HStack>
                    </Stack>
                    <Spacer />
                    <Stack spacing={"10px"}>

                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">IIR NUMBER: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.itemnos} </Text>
                        </HStack>
                    </Stack>
                </HStack>
                <HStack >
                    <Stack spacing={"10px"}>
                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">Suppliers Name: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.suppliersname} </Text>
                        </HStack>
                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">Invoice no: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.invoicenumber} </Text>
                        </HStack>
                    </Stack>
                    <Spacer />
                    <Stack spacing={"10px"}>
                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">case marking: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.staffemail} </Text>
                        </HStack>
                        <HStack>
                            <Text textTransform={"Uppercase"} fontSize={"18px"} fontWeight="600">Date received: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{moment(SingleData[0]?.datereceived).format("DD/MM/YYYY")} </Text>
                        </HStack>
                    </Stack>
                </HStack>


            </Stack>

            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Product Details</Text>
            <Stack spacing={"10px"} borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <TableContainer w={"100%"} mt="10px" overflowX="auto" color="#000"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#000">Vocab</Th>
                                <Th color="#000">ProductName</Th>
                                <Th color="#000">Status</Th>
                                <Th color="#000">Qty</Th>
                                <Th color="#000">Price</Th>
                                <Th color="#000">Value</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SingleData[0]?.product.map((item, i) => (
                                    <TableRow
                                        color='#000'
                                        key={i}
                                        vocab={item.shelfid.productshelfid}
                                        type="printSra"
                                        productName={item.shelfid.productname}
                                        status={item.status}
                                        qty={item.qtycertified || " "}
                                        price={item.price || " "}
                                        value={item.value || " "}

                                    />
                                ))
                            }

                        </Tbody>

                    </Table>
                </TableContainer>


            </Stack>

            <Flex flexDir={"column"} mt={"5px"}>

                <HStack >
                    <Text textTransform={"Uppercase"} fontSize={"14px"} fontWeight="600">Invoice Value: </Text>
                    <Spacer />
                    <Text fontSize={"14px"} fontWeight="500">{SingleData[0]?.invoicevalue} </Text>
                </HStack>
                <HStack>
                    <Text textTransform={"Uppercase"} fontSize={"14px"} fontWeight="600">Inwards Freight:</Text>
                    <Spacer />
                    <Text fontSize={"14px"} fontWeight="500">{SingleData[0]?.inwardsfreight} </Text>
                </HStack>
                <HStack>
                    <Text textTransform={"Uppercase"} fontSize={"14px"} fontWeight="600">Custom Duty: </Text>
                    <Spacer />
                    <Text fontSize={"14px"} fontWeight="500">{SingleData[0]?.customduty} </Text>
                </HStack>
                <HStack>
                    <Text textTransform={"Uppercase"} fontSize={"14px"} fontWeight="600">Total: </Text>
                    <Spacer />
                    <Text fontSize={"14px"} fontWeight="500">{SingleData[0]?.total} </Text>
                </HStack>
            </Flex>

            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Remarks</Text>
            <Stack spacing={"10px"} borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <TableContainer w={"100%"} mt="10px" color="#000"

                >
                    <Table variant='simple' size='sm' >
                        <Thead>
                            <Tr>
                                <Th color="#000"></Th>
                                <Th color="#000">Raised</Th>
                                <Th color="#000">Received</Th>
                                <Th color="#000">Posted <br /> On Stock</Th>
                                <Th color="#000" flexWrap={"wrap"}>Progressed <br /> in Purchasing</Th>
                                <Th color="#000" flexWrap={"wrap"}>Posted <br /> by Account</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            <Tr>
                                <Td>Signature</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                            </Tr>
                            <Tr>
                                <Td>Designation</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                            </Tr>
                            <Tr>
                                <Td>Date</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                            </Tr>
                        </Tbody>

                    </Table>
                </TableContainer>


            </Stack>

        </Box>
    )
}
